// extracted by mini-css-extract-plugin
module.exports = {"countdownHolder":"EventCountdown_countdownHolder__2a3Px","countdownLineHolder":"EventCountdown_countdownLineHolder__P1ziT"};